import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { node, oneOfType, string } from 'prop-types';

import { isProduction } from '@ajaibid/utils';

// Toggle via ENV.  Set REACT_APP_ENABLE_RQ_DEVTOOLS=true to show devtools (ignored in production unless explicitly enabled).
const isDevtoolsEnabled = () => {
  const flag = process.env.REACT_APP_ENABLE_RQ_DEVTOOLS || 'false';
  return flag === 'true' || (!isProduction() && flag !== 'false');
};

const queryClient = new QueryClient();

const ReactQuery = ({ children }) => (
  <QueryClientProvider client={queryClient}>
    {children}
    {isDevtoolsEnabled() && <ReactQueryDevtools />}
  </QueryClientProvider>
);

ReactQuery.defaultProps = {
  children: null,
};

ReactQuery.propTypes = {
  children: oneOfType([node, string]),
};

export default ReactQuery;
